<template>
  <div class="text-body text-black-2">
    <template v-if="inherited">
      Inherited from <RouterLink :to="inherited.link">{{ inherited.name }}</RouterLink>
    </template>
    <div
      v-else-if="
        limits.limit.if ||
        limits.cap.if ||
        limits.budget.if ||
        limits.user.if ||
        limits.delivery.if ||
        limits.pushLimits.if
      "
      class="flex flex-col"
    >
      <template v-if="limits.limit.if">
        <div v-if="limits.limit.curr > 0">
          Impression limit: {{ limits.limit.curr }}
          {{ StringUtils.pluralize("impression", limits.limit.curr) }} remaining.
        </div>
        <div v-else>Impression limit exceeded</div>
      </template>
      <div v-if="limits.cap.if">
        <div v-if="limits.cap.type === VISIT.value">
          Frequency cap: Show no more than {{ limits.cap.value }}
          {{ StringUtils.pluralize("time", limits.cap.value) }} per visit
        </div>
        <div v-else-if="limits.cap.type === DAYS.value">
          Frequency cap: Show no more than {{ limits.cap.value }}
          {{ StringUtils.pluralize("time", limits.cap.value) }} over {{ limits.cap.days }}
          {{ StringUtils.pluralize("day", limits.cap.days) }}
        </div>
      </div>
      <div v-if="limits.budget.if">
        Budget limit: {{ limits.budget.curr }} ({{ limits.budget.percent }}%) remaining.
      </div>
      <template v-if="limits.user.if">
        <div v-if="limits.user.curr > 0">
          User limit: {{ limits.user.curr }}
          {{ StringUtils.pluralize("user", limits.user.curr) }}
        </div>
        <div v-else>User limit exceeded</div>
      </template>
      <template v-if="limits.delivery.if">
        <div v-if="limits.delivery.curr > 0">
          Delivery limit: {{ limits.delivery.curr }}
          {{ limits.delivery.curr > 1 ? "deliveries" : "delivery" }}
        </div>
        <div v-else>Delivery limit exceeded</div>
      </template>
      <div v-if="limits.pushLimits.if">
        <div v-if="limits.pushLimits.dailyCap">
          Daily cap: {{ limits.pushLimits.dailyCap }}
          {{ StringUtils.pluralize("message", limits.pushLimits.dailyCap) }}
        </div>
        <div v-if="limits.pushLimits.totalCap">
          Total cap: {{ limits.pushLimits.totalCap }}
          {{ StringUtils.pluralize("message", limits.pushLimits.totalCap) }}
        </div>
      </div>
    </div>
    <span v-else>-</span>
  </div>
</template>

<script setup>
import { RouterLink } from "vue-router";
import { DAYS, VISIT } from "@/utils/constants/FrequencyCapConstants";
import StringUtils from "@/utils/StringUtils";

defineProps({
  triggers: { type: Array, default: () => [] },
  inherited: { type: Object, default: null },
  limits: { type: Object, default: () => ({}) },
});
</script>
